// extracted by mini-css-extract-plugin
export default {"container":"StockDetail_container__DuSoo","sidebar":"StockDetail_sidebar__SgIlg","active":"StockDetail_active__+S8uq","content":"StockDetail_content__lVUDN"};